import { Controller } from "@hotwired/stimulus"

// Turns a search result (see _allocation_search) into an allocation row of the encart it belongs
// to: the template row is cloned with a unique index, then filled with the clicked record's id and
// label. The lettering controller picks the new inputs up through its target lifecycle callbacks.
// One instance per encart, mounted on the tab pane holding its search and its rows.
export default class extends Controller {
  static targets = ["template", "container", "searchInput", "results"]

  connect() {
    this.index = 0
  }

  add(event) {
    const { recordId, label, amount } = event.currentTarget.dataset
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.index++)
    this.containerTarget.insertAdjacentHTML("beforeend", html)

    const row = this.containerTarget.lastElementChild
    row.querySelector("[data-allocation-record-id]").value = recordId
    row.querySelector("[data-allocation-label]").textContent = label

    const amountInput = row.querySelector("[data-allocation-amount]")
    if (amountInput.hasAttribute("data-allocation-prefill-amount")) {
      amountInput.value = amount
      amountInput.max = amount
      amountInput.dispatchEvent(new Event("input", { bubbles: true }))
    }

    this.resultsTarget.innerHTML = ""
    this.searchInputTarget.value = ""
  }

  remove(event) {
    event.currentTarget.closest(".allocation-row").remove()
  }
}
